/**
 * @typedef {Object} WebVitalsMetric
 * @property {string} id
 * @property {string} name
 * @property {number} value
 * @property {number} delta
 * @property {string} rating
 * @property {Array} [entries]
 * @property {{ jsHeapSizeLimit: number, totalJSHeapSize: number, usedJSHeapSize: number }} [memory]
 */

/**
 * Reports Web Vitals metrics and augments the payload with a memory snapshot
 * when the browser exposes `performance.memory`.
 *
 * @param {(metric: WebVitalsMetric) => void} onPerfEntry Callback that receives each Web Vitals metric.
 */
const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      const withMemory = metric => {
        let memory;
        if (typeof performance !== 'undefined' && performance.memory) {
          const { jsHeapSizeLimit, totalJSHeapSize, usedJSHeapSize } = performance.memory;
          memory = { jsHeapSizeLimit, totalJSHeapSize, usedJSHeapSize };
        }

        onPerfEntry({
          ...metric,
          ...(memory ? { memory } : {}),
        });
      };

      getCLS(withMemory);
      getFID(withMemory);
      getFCP(withMemory);
      getLCP(withMemory);
      getTTFB(withMemory);
    });
  }
};

export default reportWebVitals;
